import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../../globals';
import { OdsServices } from '../../../../services';
/**
 * Generated class for the CartaPartialDishProdSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-menu-create-selected',
    templateUrl: 'ods-config-menu-create-selected.html',
})
export class OdsConfigMenuCreateSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public translate: TranslateService,
        public odsServices: OdsServices) {
    }

    deleteElement(index) {
        if (index >= 0) {
            this.odsServices.selected_elements.splice(index, 1);
            this.odsServices.selected_elements = [...this.odsServices.selected_elements];
        }
    }

    reorderElements(indexes) {
        var element = this.odsServices.selected_elements[indexes.from];
        this.odsServices.selected_elements.splice(indexes.from, 1);
        this.odsServices.selected_elements.splice(indexes.to, 0, element);
    }

}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-selected/ods-config-menu-create-selected.ts